import React, { useCallback, useLayoutEffect, useState } from 'react';
import qs from 'query-string';

import Gift from 'app/components/common/gift/Gift';
import styles from './GiftPreview.module.css';

interface IHash {
  imageURL?: string,
  amount?: number,
  platformName?: string,
  currency?: string,
  expiration?: string,
  terms?: string,
}

const init = {
  imageURL: '',
  amount: 0,
  platformName: '',
  currency: '',
  expiration: '',
  terms: '',
};

const GiftPreview: React.FC = () => {
  const handleOpen = useCallback(() => true, []);

  const [imageURL, setImageURL] = useState(init.imageURL);
  const [amount, setAmount] = useState(init.amount);
  const [platformName, setPlatformName] = useState(init.platformName);
  const [currency, setCurrency] = useState(init.currency);
  const [expiration, setExpiration] = useState(init.expiration);
  const [terms, setTerms] = useState(init.terms);

  const parseHash = (hash: string) => {
    const results: IHash = qs.parse(hash);
    setImageURL(results.imageURL || init.imageURL);
    setAmount(results.amount || init.amount);
    setPlatformName(results.platformName || init.platformName);
    setCurrency(results.currency || init.currency);
    setExpiration(results.expiration || init.expiration);
    setTerms(results.terms || init.terms);
  };

  const handleHashChange = useCallback(() => {
    parseHash(window.location.hash);
  }, []);

  useLayoutEffect(() => {
    window.addEventListener('hashchange', handleHashChange, false);
    handleHashChange();
    return () => {
      window.removeEventListener('hashchange', handleHashChange, false);
    };
  }, [handleHashChange]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <Gift
          id={0}
          type="virtual"
          isCardsnacksCash={false}
          source="demo"
          image={imageURL}
          currency={{ symbol: currency, value: '' }}
          amount={amount}
          platform={{ name: platformName }}
          buttonText="open"
          onButtonClick={handleOpen}
          hasTerms={Boolean(terms)}
        />
      </div>
    </div>
  );
};

export default GiftPreview;
